<script setup lang="ts">
import type { TabItem } from '@/shared/models/shared.model'
import BaseButton from './BaseButton.vue'

interface Props {
  items: TabItem[]
}

defineProps<Props>()

const model = defineModel<number>({ required: true })

const onChange = (index: number): void => {
  model.value = index
}
</script>

<template>
  <ul class="flex items-center bg-gray-100 p-1 w-full">
    <li v-for="(item, index) in items" :key="index" class="w-full">
      <BaseButton
        :title="item.label"
        class="text-sm p-1 rounded-sm w-full"
        :class="model === index ? 'bg-white text-brand shadow-sm' : 'text-gray-700 hover:text-brand'"
        @click="onChange(index)"
      >
        {{ item.label }}
      </BaseButton>
    </li>
  </ul>
</template>
